export default __webpack_public_path__ + "static/media/saddle_height.6fbc4b3f.jpeg";